import { BodyBasedExpression } from '../Expression.js';
export class MaxExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const body = this.getBody().evaluate(visitor);
        const left = this.getSource().evaluate(visitor, localVariables);
        return Math.max(left, body);
    }
}
//# sourceMappingURL=MaxExpression.js.map